module.exports = __webpack_public_path__ + "assets/img/085d-ba.svg";